import { render, staticRenderFns } from "./IndividualIndividualRelation.vue?vue&type=template&id=6cf79729"
import script from "./IndividualIndividualRelation.vue?vue&type=script&lang=ts"
export * from "./IndividualIndividualRelation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports